import { httpService, WebRequestFactory, withCamelResponse, fromStatusCodeToGenericError } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";
import { ISettingsModel } from "../interfaces/ISettingsModel";
import { BackendGetAccountSettingsResponse } from "../types/BackendGetAccountSettingsResponse";
import { settingsModelMapper } from "../mappers/SettingsModelMapper.function";

export const getAccountSettings = WebRequestFactory.createGet<ISettingsModel>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: withCamelResponse<BackendGetAccountSettingsResponse, ISettingsModel>(settingsModelMapper),
    url: () => apiConfig.accountSettings()
});
